import { authApi } from './auth.api'
import { decodeJwt } from './jwt'
import type { TokenProvider } from './tokenProvider'

/**
 * Email/password sign-in against the IFS backend. The access token is kept in memory only
 * (spec §12). The backend has no refresh endpoint yet, so the session lasts until the token
 * expires or the page is reloaded; then the user signs in again.
 */
export function createPasswordTokenProvider(): TokenProvider {
  let token: string | null = null
  let expiresAt = Infinity

  const clear = () => {
    token = null
    expiresAt = Infinity
  }
  const current = () => {
    if (token && Date.now() >= expiresAt) clear()
    return token
  }

  return {
    kind: 'password',
    init() {
      return Promise.resolve(false)
    },
    getAccessToken() {
      return Promise.resolve(current())
    },
    /** Nothing to renew with: null makes the HTTP client end the session. */
    refresh() {
      clear()
      return Promise.resolve(null)
    },
    async signInWithPassword(request) {
      const res = await authApi.login(request)
      if (res.accessToken) {
        token = res.accessToken
        const { exp } = decodeJwt(res.accessToken)
        expiresAt = exp ? exp * 1000 : Infinity
      }
      return res
    },
    signIn() {
      return Promise.reject(new Error('Password sign-in uses signInWithPassword()'))
    },
    handleCallback() {
      return Promise.resolve(undefined)
    },
    signOut() {
      clear()
      return Promise.resolve()
    },
  }
}
